const message = {
  select: "Selecciona",
  team: "equipo",
  submit: "Enviar",
  collaborator: "colaborador",
  create: "crear",
  site: "centro",
  categories: "categorías",
  download: "descargar",
  totalHours: "total horas",
  polyvalence: "polivalencia",
  total: "total",
  edit: "Editar",
  remove: "Eliminar",
  date: "fecha",
  restore: "restaurar",
  areYouSure: "¿Estás seguro?",
  restoreProcess: "estás a punto de restaurar un proceso eliminado!",
  yes_i_understand: "Sí, entiendo",
  cancel: "Cancelar",
  showDeletedProcesses: "mostrar procesos eliminados",
  update: "actualizar",
  restore_description: "Estás a punto de restaurar un proceso eliminado",
  deleteDescription: "Estás a punto de eliminar un proceso",
  requiredFieldsAreMissing: "falta rellenar campos obligatorios",
  errNetwork: "Servicio no disponible",
  err400: "datos inválidos",
  err403: "no tienes acceso",
  err404: "Página no disponible",
  err409: "Conflicto con el registro",
  err500: "Error en el servicio",
  err501: "Servidor no disponible",
  "Site not Found": "centro no encontrado",
  pending_save: "Pendiente de guardar",
  hours_pending_save_description: "Estás a punto de perder las horas declaradas",
  save: "guardar",
  ignore: "Ignorar",
  destroyed_hours: "horas destruidas",
  recovered_hours: "horas recuperadas",
  saved_hours: "horas guardadas",
  recovered_process: "horas recuperadas",
  delete_category_description: "Estás a punto de eliminar una categoría",
  delete_site_description: "Estás a punto de eliminar un centro",
  deleted_category: "La categoria ha sido eliminada",
  deleted_site: "El centro ha sido eliminado",
  required_field: "Campo requerido",
  required_field_category_description: "el campo descripcion requerido",
  required_field_category_name: "el campo nombre requerido",
  required_field_fedid_site_code: "el campo codigo del centro de fedid requerido",
  required_field_site_name: "el campo nombre del centro es requerido",
  required_field_site_code: "el campo código del centro es requerido",
  created_category: "La categoria ha sido creada",
  created_site: "El centro ha sido creado",
  "Activity duration exceding 9 Hours.": "no puede declarar más de 9h en un dia",
  change_your_site: "cambia tu centro",
  change_your_team: "cambia tu equipo",
  change_your_email: "cambia tu email",
  have_api_planning: "Api planning disponible",
  table_is_empty: "La tabla está vacía",
  add_to_drive: "añadir a mi google drive",
  configuration: "Configuración",
  economic: "económico",
  explotation: "explotación",
  account: "cuenta",
  hda: "hda",
  "Total Hours of whole activities is more than 9h.": "total de horas de la actividad no puede ser superior a 9h",
  "bad request": "datos inválidos",
  "page not found": "Página no encontrada",
  select_date: "seleccionar fecha",
  select_week: "selecciona semana",
  select_team: "selecciona equipo",
  select_collaborator: "selecciona colaborador",
  date_from: "fecha inicial",
  date_to: "fecha final",
  more_options: "más opciones",
  close_dialog: "cerrar el dialogo",
  where_you_have_worked: "donde ha trabajado",
  when_you_have_worked: "cuando has trabajado",
  the_week_what_do_you_search: "la semana que quiere buscar",
  the_team_what_do_you_search: "el equipo que quiere buscar",
  the_collaborator_what_do_you_search: "el colaborador que quiere buscar",
  site_name: "nombre del centro",
  site_code: "código del centro",
  fedid_site_code_openid: "código del centro en openId",
  fedid_site_code: "código del centro",
  site_code_planning: "código del centro en planning",
  categoryName: "nombre de la categoría",
  category_description: "Descripción de la categoría",
  user_title: "colaborador",
  total_hours_title: "h. trabajadas",
  total_hours_provider_title: "total h. planning",
  difference_hours_title: "diferencia h.",
  hours_in_team_title: "h. equipo",
  given_polyvalence_title: "poliv. dada",
  received_polyvalence_title: "poliv. recibida",
  process: "proceso",
  polyvalence_team: "equipo poliv.",
  hours: "horas",
  date_title: "fecha",
  name: "nombre",
  planning_code: "código centro en planning",
  fedid_code: "código centro en fedid",
  description: "Descripción",
  reset_form: "reset form",
  provider_api: "Conectado con planning",
  no: "no",
  yes: "si",
  your_email_does_not_exist_in_the_app: "Tu perfil no existe en la aplicación",
  we_can_create_a_fictitious_profile_in_a_fictitious_center: "Puede crear un perfil ficticio en un centro ficticio",
  you_are_about_to_create_a_fictitious_profile_in_a_fictitious_center:
    "estás a punto de crear un perfil ficticio en un centro ficticio",
  the_value_should_between_0_and_9: "la cantidad de horas declaradas debe ser entre 0h y 9h",
  excel: "excel",
  no_content: "no tiene contenido",
  "logistic process": "proceso",
  total_hours: "total horas",
  planning: "planning",
  hours_team: "horas equipo",
  diff: "diferencia",
  given_polyvalence: "poli. dada",
  received_polyvalence: "poli. recibida",
  logistic_process: "proceso",
  dates_error: "error en las fechas",
  date_from_is_later_than_date_to: "la fecha inicial es posterior a la fecha final",
  username: "perfil",
  dni: "DNI",
  uuid: "uuid",
  sap_number: "número sap",
  email: "Correo",
  select_site: "selecciona centro",
  new_collaborator: "nuevo col.",
  all_fields_are_required: "todos los campos son requeridos",
  field_are_required: "campos requeridos",
  sap_structure_number: "número de sap",
  delete_team_description: "Está a punto de eliminar un equipo",
  "deleted/notDeleted": "eliminados o no eliminados",
  total_hda: "total hda",
  total_team: "total equipo",
  ask_support: "ticket soporte it",
  users: "usuarios",
  team_that_you_search: "el equipo que buscas",
  center: "centro",
  mail: "email",
  service: "servicio",
  uid: "perfil",
  branch: "rama",
  username_that_you_search: "perfil que buscas",
  personal_data: "datos personales",
  last_name: "apellido",
  center_data: "data del centro",
  complementary_data: "datos complementarios",
  your_dni: "dni",
  you_are_about_delete_a_user: "Estás a punto de eliminar un usuario",
  user: "usuario",
  you_are_about_to_delete_a_team:
    "Estás a punto de eliminar un equipo, por favor revisa si el equipo tiene colaboradores dentro si es asi no lo elimines ya que no puedes acceder a ellos posteriormente",
  you_are_about_create_a_planning: "estás a punto de create un planning",
  hour_in: "hora inicio",
  hour_out: "hora final",
  manual: "manual",
  is_manual_user: "es un usuario manual",
  sites: "centros",
  sites_where_has_access: "centros al que tiene acceso",
  select_multi_vada: "seleccione multi vada",
  change_site: "cambia de almacén",
  hour_out_is_smaller_than_hour_in: "la hora de entrada no puede ser igual o menor que hora de salida",
  careful: "cuidado",
  dangerous: "peligroso",
  total_days: "total días",
  dont_forget_edit_form: "No olvide seleccionar los centros",
  no_options: "No hay opciones",
  active: "activo",
  deleted: "eliminado",
  add_new_field: "Añadir nuevo campo",
  add_field: "Añadir campo",
  field_name: "Nombre del campo",
  no_custom_fields_added: "No se han añadido campos personalizados",
  invalid_email: "Correo inválido",
  "email_without_@decathlon.com": "El correo debe contener {'@'}decathlon.com",
  "collaboratormail@decathlon.com": "colaborador{'@'}decathlon.com",
  required_filed_category_name: "El nombre de la categoría es obligatorio",
  required_filed_category_description: "La descripción de la categoría es obligatoria",
  created_collaborator: "Colaborador creado",
  remove_visitor_description: "Estás a punto de registrar la salida del visitante",
  search_by_name_or_badge: "Buscar por nombre o badge...",
  selected: "seleccionados",
  clean_selection: "Limpiar selección",

  site_form: {
    name: "Nombre del centro",
    name_placeholder: "Nombre",
    code: "Código del centro",
    code_placeholder: "Código",
    code_fedid: "Código FEDID del centro",
    code_fedid_placeholder: "Código FEDID",
    planning: "Conectado con planning",
  },
  category_form: {
    name: "Nombre de la categoría",
    name_placeholder: "nombre",
    desc: "Descripción de la categoría",
    desc_placeholder: "Descripción",
  },
  collaborator_form: {
    name: "Nombre Completo",
    name_placeholder: "Nombre",
    username: "Perfil",
    username_placeholder: "Perfil",
    dni: "DNI",
    dni_placeholder: "DNI",
    uuid: "UUID",
    uuid_placeholder: "Uuid",
    sap: "Número SAP",
    sap_placeholder: "Número SAP",
    email: "Correo electrónico",
    email_placeholder: "Correo",
    sites: "Seleccionar centros VADA",
    manual: "Usuario manual",
  },
  team_form: {
    name: "Nombre",
    name_placeholder: "Nombre",
    desc: "Descripción",
    des_placeholder: "Descripción",
    sap: "Número de SAP",
    sap_placeholder: "Número SAP",
    uuid: "Uuid",
    uuid_placeholder: "Uuid",
  },

  add: "Añadir",
  delete_collaborator_description: "Estas a punto de eliminar a un colaborador",
  deleted_collaborator: "Colaborador eliminado",
  search_by_mail: "Buscar colaborador por email",
  user_not_found_or_error: "Usuario no encontrado o ha habido un error",
  usurpation_completed: "Usurpación realizada con éxito",
  usurpate: "Usurpar",
  search: "Buscar",
  removed_team: "Equipo eliminado",
  updated_collaborator: "Colaborador actualizado",

  process_created: "Proceso creado",
  error_creating_process: "Error creando el proceso",
  process_name: "Nombre del proceso",
  process_form_name_placeholder: "Nombre",
  process_form_description_placeholder: "Descripción",
  process_form_minutes_placeholder: "Min",
  process_form_max_hours_placeholder: "Máx. horas",
  category: "Categoría",
  dangerous_process: "Proceso peligroso",
  max_hours_inversion: "Máximo de horas invertidas",
  select_option: "Selecciona una opción",
  fill_required_fields: "Por favor rellene el campo que falta",
  process_updated: "Proceso actualizado",
  error_updating: "Error en la actualización del proceso",
  visitors: "Visitantes",
  new_visitor: "Nuevo visitante",
  all: "Todos",
  visitor_data: "Datos",
  visitors_evacuation_download: "Evacuación",
  visitors_evacuation_download_error: "No se pudo descargar el reporte de evacuación",
  no_visitors: "No hay visitantes",
  no_more_visitors: "No hay más visitantes",
  badge: "Badge",
  all_categories: "Todas las categorías",
  from: "Desde",
  to: "Hasta",
  reset_filters: "Limpiar",
  select_category: "Selecciona una categoría",
  no_categories_available: "No se encontraron categorías disponibles.",
  back: "Volver",
  complete_required_info: "Complete la información requerida para registrar el acceso.",
  cancel_registration: "Cancelar registro",
  loading_options: "Cargando opciones...",
  registering: "Registrando...",
  register_entry: "Registrar entrada",
  more_info: "Más información",
  logout: "Cerrar sesión",
  fields: "Campos",
  visitorsSites: "centros",
  visitorsTeams: "Equipos",
  leaders: "líderes",
  visitorsCategories: "Categorías",
  liberate: "Liberar",
  Auditors: "Auditores",
  results: "Resultados",
  previous: "Anterior",
  next: "Siguiente",
  showing: "Mostrando",
  of: "de",
  visitors_data: "Datos",
  form: "Formulario",
  exit_visitor: "Registrar salida",
  press_enter_to_add_email: "Escribe los correos separados por espacios y presiona enter para añadirlos",
  visitor_site_form: {
    emails: "correos",
    emails_placeholder: "ejemplo{'@'}decathlon.com",
  },
  close: "cerrar",
  emails: "correos",
  no_data: "No hay datos",
  view: "Ver",
  type: "Tipo",
  validation: "Validación",
  actions: "Acciones",
  required: "Requerido",
  optional: "Opcional",
  label: "Etiqueta",
  placeholder: "Texto de ayuda",
  field_name_example: "Ej: user_age",
  field_label_example: "Ej: Edad del usuario",
  field_help_text_placeholder: "Texto de ayuda...",
  field_select_placeholder_example: "Ej: Seleccione una opción...",
  url_placeholder: "https://...",
  category_name_example: "Ej: Visita VIP",
  category_description_short_placeholder: "Descripción breve de la categoría...",
  search_field_name_or_label: "Buscar campo por nombre o etiqueta...",
  write_here: "Escribe aquí...",
  continue: "Continuar",
  custom_color: "Color personalizado",
  select_a_color: "Selecciona un color",
  email_placeholder_default: "ejemplo@correo.com",
  field_type_text: "Texto",
  field_type_number: "Número",
  field_type_select: "Selección",
  field_type_checkbox: "Checkbox",
  field_type_calendar: "Fecha",
  reserved_space: "Espacio reservado",
  loading: "Cargando",
  success: "Éxito",
  error: "Error",
  not_found: "No encontrado",
  visitor_data_loaded: "Datos del visitante cargados correctamente",
  visitor_not_found_key_value: "No hay registros previos con este valor",
  search_error: "Error al buscar los datos del visitante",
  ok: "OK",
  unknown: "Desconocido",
  register_error: "Error de registro",
  error_500: "Error inesperado del servidor",
  error_deleting: "Error al eliminar",
  language_spanish: "Español",
  language_english: "Inglés",
  language_french: "Francés",
  edit_field: "Editar campo",
  new_field: "Nuevo campo",
  edit_category: "Editar categoría",
  config_fields_subtitle_edit: "Modifica los datos del campo existente.",
  config_fields_subtitle_create: "Define las propiedades y configuración del nuevo input.",
  config_categories_subtitle: "Define el nombre, color y los campos que compondrán el formulario de esta categoría.",
  validation_error: "Error de validación",
  updated_successfully: "Actualizado correctamente",
  created_successfully: "Creado correctamente",
  form_error_loading_data: "Ocurrió un error al cargar los datos.",
  form_error_saving_retry: "Ocurrió un error al guardar. Inténtalo de nuevo.",
  config_error_loading_available_sites: "No se pudieron cargar los centros disponibles.",
  config_error_loading_available_teams: "No se pudieron cargar los equipos disponibles.",
  config_error_loading_sites_list: "No se pudo cargar la lista de centros.",
  config_error_loading_teams_list: "No se pudo cargar la lista de equipos.",
  config_error_loading_list: "No se pudo cargar la lista.",
  config_error_loading_categories_list: "No se pudo cargar la lista de categorías.",
  config_error_loading_fields_list: "No se pudo cargar la lista de campos.",
  config_error_saving_site: "Error al guardar el centro",
  config_error_unexpected_server: "Ocurrió un error inesperado al comunicar con el servidor.",
  config_error_saving_team: "Error al guardar el equipo",
  config_error_saving_leader: "Error al guardar el líder",
  config_error_saving_category: "Error al guardar la categoría",
  config_error_deleting_site: "Error al eliminar el centro",
  config_error_deleting_team: "Error al eliminar el equipo",
  config_error_deleting_leader: "Error al eliminar el líder",
  config_error_deleting_category: "Error al eliminar la categoría",
  config_error_deleting_field: "Error al eliminar el campo",
  config_error_loading_site_teams: "No se pudieron cargar los equipos de este centro.",
  config_error_loading_teams: "Error al cargar equipos",
  config_error_loading_form_data: "Error al cargar los datos del formulario",
  config_error_saving_form: "Error al guardar el formulario",
  visitors_error_loading_history: "No se pudo cargar el historial de visitantes.",
  visitors_error_loading_categories: "No se pudieron cargar las categorías.",
  visitors_error_category_data_not_found: "No se encontraron datos para esta categoría.",
  visitors_error_loading_form_config: "No se pudo cargar la configuración del formulario.",
  visitors_registered_successfully: "El visitante ha sido registrado correctamente.",
  visitors_error_registering: "No se pudo registrar al visitante. Inténtalo de nuevo.",
  exit_registered: "Salida registrada",
  visitors_exit_registered_successfully: "Se ha registrado la salida del visitante correctamente.",
  visitors_error_registering_exit: "No se pudo registrar la salida del visitante.",
  visitors_invalid_date_range: "La fecha hasta debe ser igual o posterior a la fecha desde.",
  visitors_missing_center_code: "No se pudo obtener el código de centro para filtrar el historial.",
  visitor_default_name: "Visitante",
  visitor_without_name: "Visitante sin nombre",
  without_number: "Sin número",
  option_without_name: "Opción sin nombre",
  field_without_valid_source_url: "El campo {field} no tiene un sourceUrl válido.",
  subtype: "Subtipo",
  is_required: "Obligatorio",
  new: "Nuevo",
  key: "Key",
  teams: "Equipos",
  color: "Color",
  required_field_error: "Por favor, completa los campos obligatorios",
  select_fields_preview: "Selecciona los campos para previsualizarlos aquí.",
  new_category: "Nueva categoría",
  preview_category_form: "Vista Previa (Formulario Final)",
  required_abreviation: "Req",
  fields_not_found: "No se encontraron campos.",
  select_inputs: "Selecciona los inputs",
  link_href: "Enlace (Href)",
  source_url: "URL de origen",
  no_results: "No se encontraron resultados",
  deleted_team: "Equipo eliminado",
  deleted_leader: "Líder eliminado",
  delete_leader_description: "Estas a punto de eliminar a un líder",
  updated_leader: "Líder actualizado",
  created_leader: "Líder creado",
  updated_site: "Centro actualizado",
  type_of_select: "Tipo de selección",
  team_deleted: "Equipo eliminado",
  impersonating: "Usurpando a",
  clear_search: "Limpiar búsqueda",
  deleted_field: "Campo eliminado",
  delete_field_description: "Estas a punto de eliminar un campo",
  created_field: "Campo creado",
  updated_field: "Campo actualizado",
  created_team: "Equipo creado",
  updated_team: "Equipo actualizado",
  updated_category: "Categoría actualizada",
  no_data_available: "No hay datos disponibles",

  bookings: {
    status: {
      RETURNED_WITH_INCIDENT: "Devuelto con incidencia",
      RETURNED: "Devuelto",
      CANCELLED: "Cancelado",
      PICKED_UP: "Recogido",
      PENDING_CHECKOUT: "Pendiente de salida",
    },
    filters: {
      state: "Estado",
      searchPlaceholder: "Buscar...",
      clearFilters: "Limpiar Filtros",
      fromDate: "Desde",
      toDate: "Hasta",
      clear: "Limpiar filtros",
    },
    admin: {
      common: {
        resultCount: "Ningún resultado | 1 resultado | {count} resultados",
        searchName: "Buscar por nombre",
      },
      dashboard: {
        title: "Panel de administración",
        subtitle: "Supervisa la operación diaria y accede a las herramientas de gestión del centro.",
        overview: "Resumen operativo",
        overviewHint: "Indicadores clave de actividad y alertas del día.",
        operations: "Operación diaria",
        operationsHint: "Gestión de reservas, stock y mantenimiento.",
        control: "Control y análisis",
        controlHint: "Auditoría, métricas y configuración del catálogo.",
        alert: "Atención",
        pendingPickups: "Entregas pendientes",
        pendingReturns: "Recepciones pendientes",
        inMaintenance: "En mantenimiento",
        expiredReservations: "Reservas vencidas",
        todayReservations: "Solicitudes hoy",
        attentionAlerts: "Alertas activas",
        sections: "Secciones",
        partialError: "Algunos datos no pudieron cargarse. El resto del panel está disponible.",
        activityTitle: "Actividad (últimos 7 días)",
        maintenanceHint: "Unidades bloqueadas pendientes de cerrar mantenimiento.",
        maintenanceViewAll: "Ver todos los mantenimientos",
        alertList: {
          title: "Centro de atención",
          hint: "Reservas que requieren acción inmediata: retrasos, vencimientos y alertas.",
        },
        quickActions: {
          title: "Acciones rápidas",
          viewAllDeliveries: "Ver todas las entregas",
          viewAllReturns: "Ver todas las recepciones",
        },
        inventoryRisk: {
          section: "Stock crítico",
          title: "Productos con disponibilidad baja o nula",
          hint: "Productos con 0 unidades disponibles o con menos del 25 % de su stock libre.",
          empty: "No hay productos con stock crítico",
          product: "Producto",
        },
      },
      reservations: {
        title: "Gestión de reservas",
        description: "Verifica entregas y recepciones. Localiza reservas por colaborador o referencia.",
        empty: "No hay reservas que mostrar",
        emptyHint: "Prueba otra búsqueda o cambia de pestaña.",
        emptyDeliveries: "No hay entregas pendientes",
        emptyReturns: "No hay recepciones pendientes",
        emptyAttention: "No hay alertas operativas",
        searchLabel: "Buscar reserva",
        searchPlaceholder: "Colaborador, referencia o centro…",
        refresh: "Actualizar",
        viewDetail: "Ver detalle",
        confirmDeliveryPrompt: "¿Confirmas que el material ha sido entregado al colaborador?",
        tabsLabel: "Colas operativas",
        tabs: {
          deliveries: "Entregas",
          returns: "Recepciones",
          attention: "Atención",
          all: "Todas",
        },
        queues: {
          deliveries: "Entregas pendientes",
          returns: "Recepciones pendientes",
          delays: "Retrasos",
          expiringSoon: "Por expirar",
          deliveriesTitle: "Cola de entregas",
          returnsTitle: "Cola de recepciones",
          deliveriesHint: "Reservas solicitadas pendientes de entrega física del material.",
          returnsHint: "Material en uso pendiente de recepción y verificación al devolver.",
        },
        attention: {
          title: "Requiere atención",
          subtitle:
            "Retrasos, devoluciones vencidas o reservas a punto de expirar. Contacta con el colaborador responsable.",
          viewAll: "Ver todas",
          overdueReturn: "Devolución vencida — contactar al colaborador",
          returnToday: "Devolución prevista hoy",
          returnTomorrow: "Devolución prevista mañana",
          deliveryOverdue: "Entrega retrasada — el inicio del préstamo ya pasó",
          deliveryToday: "Entrega prevista hoy",
          deliveryTomorrow: "Entrega prevista mañana",
          cartExpiringSoon: "Cesta a punto de expirar",
          cartExpired: "Cesta expirada o reserva no tramitada",
        },
      },
      inventory: {
        title: "Inventario",
        totalUnits: "Unidades totales",
        availableUnits: "Disponibles",
        reservedUnits: "Reservadas",
        maintenanceUnits: "En mantenimiento",
        description: "Consulta el stock de productos y unidades",
        total: "Total",
        available: "Disponibles",
        stockLevel: "Nivel de stock",
        stockSummary: "{available} / {total} disponibles",
        stockBarLabel: "Stock disponible {available} de {total}",
        inUseOrUnavailable: "No disponibles",
        addProduct: "Nuevo producto",
        autoMaintenanceOnReturn: "Pasar automáticamente a mantenimiento al devolver",
      },
      units: {
        title: "Unidades",
        serialNumber: "Número de serie",
        state: "Estado",
        location: "Ubicación",
        tableAriaLabel: "Unidades del producto",
        sendToMaintenance: "Enviar a mantenimiento",
        sendToMaintenanceTitle: "¿Mandar a mantenimiento?",
        sendToMaintenanceDescription: "¿Confirmas que la unidad {unit} pasará a mantenimiento?",
        sendToMaintenanceReason: "Trasladado manualmente desde inventario por estar dañado",
        sendToMaintenanceSuccess: "Unidad enviada a mantenimiento",
        sendToMaintenanceError: "Error al enviar a mantenimiento",
        history: "Historial",
        noUnits: "No hay unidades registradas para este producto",
        noHistory: "Sin historial de cambios de estado",
        placeholder: "Sin información adicional",
        addUnit: "Añadir unidad",
        serialPrefix: "Prefijo de serie",
        locationPlaceholder: "Ej. Pasillo 3, Estante A",
        quantity: "Cantidad",
        delete_description: "Estás a punto de eliminar esta unidad",
        editUnit: "Editar unidad",
        noHistoryDescription: "Esta unidad no tiene historial registrado",
      },
      maintenance: {
        title: "Mantenimiento",
        open: "Mantenimientos abiertos",
        close: "Cerrar mantenimiento",
        noMaintenance: "No hay mantenimientos activos",
        description: "Gestiona unidades en mantenimiento",
        openSince: "Abierto desde",
        close_description: "Estás a punto de cerrar este mantenimiento",
      },
      audit: {
        title: "Auditoría",
        noEvents: "No hay eventos de auditoría",
        detail: "Detalle del evento",
        description: "Consulta el historial de actividad del módulo de reservas",
        filtersTitle: "Filtrar eventos",
        filtersSubtitle: "Acota por periodo o tipo de evento para revisar la trazabilidad",
        eventTypePlaceholder: "Tipo de evento (ej. PICKED_UP)",
        quickFilters: "Accesos rápidos",
        chips: {
          all: "Todos",
          reservations: "Reservas",
          pickups: "Entregas",
          returns: "Recepciones",
          cancelled: "Cancelaciones",
        },
        fields: {
          aggregate: "Agregado",
          correlation: "Correlación",
          payload: "Datos del evento",
        },
      },
      analytics: {
        title: "Analytics",
        reservations: "Reservas",
        utilization: "Utilización",
        description: "Métricas y tendencias del módulo de reservas",
        noData: "Sin datos para el período seleccionado",
        confirmed: "Solicitudes registradas",
        filtersTitle: "Periodo de análisis",
        filtersSubtitle: "Selecciona un rango de fechas o usa un acceso rápido",
        periodSummary: "Mostrando métricas del {from} al {to}",
        dailyBreakdown: "Desglose diario",
        dailyBreakdownHint: "Evolución de solicitudes, entregas y recepciones por día",
        presets: {
          last7: "Últimos 7 días",
          last30: "Últimos 30 días",
          last90: "Últimos 90 días",
        },
        charts: {
          dailyTrend: "Actividad diaria",
          dailyTrendHint: "Comparativa por día de solicitudes, entregas, recepciones y cancelaciones",
          periodMix: "Distribución del periodo",
          periodMixHint: "Peso relativo de cada tipo de operación en el rango filtrado",
          confirmed: "Solicitudes",
          total: "Total",
          noActivity: "Sin actividad registrada en este periodo",
        },
      },
      catalog: {
        title: "Catálogo",
        description: "Gestiona tipos, categorías, subcategorías y productos",
        filtersTitle: "Filtros del catálogo",
        filtersSubtitle: "Selecciona el nivel y busca por nombre para localizar elementos rápidamente",
        tableTypes: "Tipos de reserva",
        tableCategories: "Categorías",
        tableSubCategories: "Subcategorías",
        addType: "Nuevo tipo",
        addCategory: "Nueva categoría",
        addSubCategory: "Nueva subcategoría",
        selectType: "Selecciona un tipo",
        selectCategory: "Selecciona una categoría",
        status: "Estado",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        confirmDelete: "¿Confirmar eliminación?",
      },
      actions: {
        managementTitle: "Verificación de material",
        pickup: "Confirmar entrega",
        pickupHint: "Verifica que el material se ha entregado al colaborador antes de confirmar.",
        return: "Confirmar recepción",
        returnHint: "Verifica el estado del material devuelto al finalizar el préstamo.",
        noActionHint: "No hay acciones pendientes para este estado.",
        cancel: "Cancelar reserva",
        createType: "Crear tipo",
        editType: "Editar tipo",
        createProduct: "Crear producto",
        editProduct: "Editar producto",
        addUnit: "Añadir unidad",
        changeState: "Cambiar estado",
        returnCondition: "Estado del material devuelto",
        conditionGood: "Bueno",
        conditionDamaged: "Dañado",
        conditionLost: "Perdido",
        incidentNotes: "Notas de incidencia",
        deliveryConfirmed: "Entrega confirmada",
        returnConfirmed: "Recepción confirmada",
        confirmReturnTitle: "Confirmar devolución",
        confirmReturnGood: "En buen estado",
        confirmReturnYes: "Sí, confirmar",
      },
      reservationDetail: {
        timeline: "Historial",
        requestedAt: "Solicitud registrada",
        deliveredAt: "Entrega confirmada",
        returnedAt: "Recepción confirmada",
      },
    },
    unitStates: {
      AVAILABLE: "Disponible",
      RESERVED: "Reservada",
      IN_USE: "En uso",
      IN_MAINTENANCE: "En mantenimiento",
      LOST: "Perdida",
      RETIRED: "Retirada",
      DAMAGED: "Dañada",
      undefined: "Desconocido",
    },
    home: {
      title: "Gestión de Préstamos",
      description: "Añade material a tu cesta desde cualquier categoría y confirma las fechas al tramitar la reserva",
      subtitleShort: "Consulta avisos de tus préstamos y explora el catálogo por tipo, categoría o búsqueda",
      browse: "Ver catálogo",
      cart: "Mi cesta",
      myReservations: "Mis reservas",
      adminPanel: "Panel admin",
      searchTitle: "Buscar material",
      searchDescription: "Encuentra productos en todo el catálogo, sin importar tipo o categoría",
      browseByType: "Explorar por tipo",
      browseByTypeHint:
        "Opcional: navega por el catálogo y combina productos de distintas categorías en la misma cesta",
      alerts: {
        title: "Tus avisos",
        empty: "No tienes préstamos que requieran acción ahora mismo",
        viewReservation: "Ver reserva",
        viewReservations: "Mis reservas",
        localCartExpired: "Tu cesta ha caducado — vacíala o vuelve a tramitarla",
        overdueReturn: "Devolución pendiente — has superado la fecha límite",
        returnToday: "Devolución prevista hoy",
        returnTomorrow: "Devolución prevista mañana",
        deliveryOverdue: "Recogida pendiente — ya deberías haber recogido el material",
        deliveryToday: "Recogida prevista hoy",
        deliveryTomorrow: "Recogida prevista mañana",
        cartExpiringSoon: "Reserva pendiente de tramitar — caduca pronto",
        cartExpired: "Reserva no tramitada — ha expirado",
      },
      recentProducts: {
        title: "Pedir de nuevo",
        subtitle: "Material que has reservado recientemente",
      },
      explorer: {
        title: "Explorar catálogo",
        subtitle: "Filtra por tipo y categoría o busca productos en todo el catálogo",
        searchPlaceholder: "Buscar por nombre, referencia...",
        startHint: "Escribe o elige un filtro para ver productos aquí mismo",
        selectTypeHint: "Elige un tipo de material",
        selectCategoryHint: "Elige una categoría",
        selectSubCategoryHint: "Elige una subcategoría",
        productsHint: "Productos disponibles en esta subcategoría",
        searchResultsHint: "Resultados de búsqueda en el catálogo",
        clearFilters: "Limpiar filtros",
        noCategories: "No hay categorías disponibles para este tipo",
        noSubCategories: "No hay subcategorías en esta categoría",
      },
      calendar: {
        title: "Calendario de préstamos",
        instruction: "Selecciona fechas",
        previousMonth: "Mes anterior",
        nextMonth: "Mes siguiente",
        legendRange: "Periodo del préstamo",
        legendPickup: "Recogida",
        legendReturn: "Devolución",
        bookedDay: "Día del préstamo: {date}",
        pickupDay: "Recogida: {date}",
        returnDay: "Devolución: {date}",
        singleDay: "Recogida y devolución: {date}",
        legendActive: "Activo",
        legendCompleted: "Completado",
        legendSelected: "Seleccionado",
      },
    },
    catalog: {
      title: "Catálogo",
      types: "Tipos de reserva",
      categories: "Categorías",
      subCategories: "Subcategorías",
      products: "Productos",
      availableUnits: "0 unidades disponibles | 1 unidad disponible | {count} unidades disponibles",
      addToCart: "Añadir a cesta",
      viewProduct: "Ver producto",
      addedToCart: "Producto añadido a la cesta. Puedes seguir explorando el catálogo.",
      quantity: "Unidades",
      increaseQuantity: "Aumentar unidades",
      decreaseQuantity: "Reducir unidades",
      noUnits: "Sin unidades disponibles",
      inCart: "0 en cesta | 1 en cesta | {count} en cesta",
      unitsAvailable: "{available} / {total} disponibles",
      maxUnitsPerReservation: "Máx. {count} por reserva",
      maxInCart: "Ya tienes el máximo disponible en la cesta",
      browseAndAdd: "Selecciona cantidades y añádelas a la cesta. Las fechas se eligen al tramitar la reserva.",
      availabilityOnCheckout: "La disponibilidad definitiva se comprobará al seleccionar las fechas en la cesta.",
      searchResults: "Resultados de búsqueda",
      searchFilters: {
        title: "Filtros de búsqueda",
        subtitle: "Combina texto, tipo, categoría y subcategoría para localizar material en todo el catálogo",
        availableOnly: "Solo productos con unidades disponibles",
        allCategories: "Todas las categorías",
        allSubCategories: "Todas las subcategorías",
        resultsCount: "0 productos encontrados | 1 producto encontrado | {count} productos encontrados",
      },
      selectDates: "Selecciona las fechas del préstamo",
      noTypes: "No hay tipos de reserva disponibles",
      noCategories: "No hay categorías disponibles",
      noSubCategories: "No hay subcategorías disponibles",
      noProducts: "No hay productos disponibles",
      available: "disponibles",
      default: "Por defecto",
      allProducts: "Todos los productos",
      subCategoriesHint: "Elige una subcategoría o consulta todos los productos de la categoría",
      searchProducts: "Buscar productos...",
      emptyProducts: "Sin productos en inventario",
      emptyTypes: "Sin tipos de reserva creados",
      errorLoad: "No se pudo cargar el catálogo",
      category: "Categoría",
      subCategory: "Subcategoría",
      type: "Tipo",
      referenceCode: "Código de referencia",
      maxDays: "Máx. días de reserva",
      maxUnits: "Máx. unidades por reserva",
      emptyCategories: "Sin categorías",
      emptyCategoriesHint:
        "Este tipo de reserva aún no tiene categorías disponibles. Vuelve al inicio y prueba otro tipo.",
      emptySubCategories: "Sin subcategorías",
      filters: {
        search: "Buscar...",
        availability: "Disponibilidad",
        status: "Estado",
        clear: "Limpiar filtros",
      },
    },
    productDetail: {
      description: "Descripción",
      specifications: "Información del producto",
      availability: "Disponibilidad actual",
    },
    images: {
      image: "Imagen",
      file: "Archivo de imagen",
      manage: "Imágenes",
      upload: "Subir imagen",
      altText: "Texto alternativo",
      markPrimary: "Marcar como imagen principal",
      primary: "Principal",
      setPrimary: "Poner principal",
      regenerate: "Regenerar",
      empty: "Sin imágenes",
      noAlt: "Sin texto alternativo",
    },
    cart: {
      title: "Mi cesta",
      subtitle: "Revisa el material seleccionado y elige las fechas para tramitar la reserva",
      empty: "Tu cesta está vacía",
      browse: "Explorar catálogo",
      period: "Período de reserva",
      selectDates: "Fechas del préstamo",
      selectDatesHint: "Indica el período en el que necesitarás el material",
      confirmRequiresDates: "Selecciona las fechas antes de solicitar la reserva",
      datesLockedByReservation: "Las fechas no se pueden modificar mientras la reserva está en proceso",
      expired: "Cesta expirada",
      expiresAt: "Expira a las {time}",
      confirm: "Solicitar reserva",
      cancel: "Cancelar cesta",
      clear: "Limpiar",
      increase: "Aumentar cantidad",
      decrease: "Reducir cantidad",
      remove: "Eliminar producto",
      confirmTitle: "¿Confirmar reserva?",
      confirmText: "Una vez confirmada, se asignarán las unidades.",
      continueBrowsing: "Seguir explorando",
      itemsTitle: "Material seleccionado",
      checkout: "Tramitar reserva",
      summary: "Resumen",
      itemsCount: "Sin productos | 1 producto | {count} productos",
      acceptLegal: "Acepta las condiciones legales",
      acceptLegalHere: "aquí",
      acceptedLegal: "Condiciones aceptadas",
      LegalConditionsTitle: "Términos y Condiciones",
      LegalConditionsSubtitle: "Debes leer hasta el final para poder aceptar.",
      acceptLegalAction: "Aceptar condiciones",
      scrollToAccept: "Desplaza para aceptar",
      viewLegal: "Ver",
      close: "Cerrar"
    },
    notifications: {
      addedToCart: "Añadido a la cesta",
      addedToCartDetail: "{name} × {count}",
      cartLimitReached: "No puedes añadir más unidades",
      cartLimitReachedDetail: "Máximo permitido: {max}",
      cartPartialAdd: "Solo se añadieron algunas unidades por límite de stock",
      removedFromCart: "Eliminado de la cesta",
      cartCleared: "Cesta vaciada",
      cartCancelled: "Reserva pendiente cancelada",
      datesApplied: "Fechas del préstamo actualizadas",
      reservationSubmitted: "Solicitud de reserva enviada",
      reservationPending: "Reserva creada. Confirma para finalizar.",
      reservationConfirmed: "Reserva confirmada",
      reservationCancelled: "Reserva cancelada",
    },
    confirmation: {
      title: "¡Solicitud enviada!",
      subtitle: "Tu solicitud de reserva ha sido registrada correctamente",
      pendingAdminDelivery:
        "Un administrador confirmará la entrega del material. La devolución también será verificada por el equipo al finalizar el préstamo.",
      reservationId: "ID de reserva",
      reservationSummary: "Resumen de la reserva",
      period: "Periodo del préstamo",
      viewMyReservations: "Ver mis reservas",
    },
    myReservations: {
      title: "Mis reservas",
      subtitle: "Consulta, filtra y gestiona todas tus reservas de material",
      empty: "No tienes reservas",
      emptyFiltered: "Ninguna reserva coincide con los filtros",
      emptyFilteredHint: "Prueba a cambiar el estado, el periodo o la búsqueda",
      itemsCount: "Sin productos | 1 producto | {count} productos",
      detail: "Detalle de reserva",
      cancel: "Cancelar reserva",
      cancelConfirm: "¿Estás seguro de que quieres cancelar esta reserva?",
      download: "Descargar documento",
      table: {
        id: "Referencia",
        createdAt: "Solicitud",
      },
      filters: {
        title: "Filtrar reservas",
        subtitle: "Refina la lista por estado, fechas o referencia",
        searchPlaceholder: "Buscar por centro, colaborador o ID...",
        stateGroup: "Estado",
        period: "Periodo",
        sort: "Ordenar por",
        expand: "Mostrar filtros",
        collapse: "Ocultar filtros",
        removeTag: "Quitar filtro",
        resultCount: "Ninguna reserva | 1 reserva encontrada | {count} reservas encontradas",
        showingRange: "Mostrando {from}-{to} de {total}",
        sortNewest: "Más recientes",
        sortOldest: "Más antiguas",
        sortFromDateAsc: "Fecha inicio (ascendente)",
        sortFromDateDesc: "Fecha inicio (descendente)",
        groups: {
          all: "Todas",
          active: "Activas",
          inProgress: "En curso",
          completed: "Finalizadas",
          cancelled: "Canceladas",
        },
        periods: {
          all: "Cualquier fecha",
          upcoming: "Próximas",
          thisMonth: "Este mes",
          last3Months: "Últimos 3 meses",
          custom: "Rango personalizado",
        },
        tags: {
          search: "Búsqueda: {query}",
          customRange: "{from} → {to}",
        },
      },
    },
    checkout: {
      title: "Confirmación de reserva",
      success: "Reserva creada con éxito",
      viewDetail: "Ver detalle",
      pending: "Pendiente de confirmación",
      confirm: "Confirmar",
    },
    confirm: {
      deleteTitle: "¿Confirmar eliminación?",
      deleteMessage: "Esta acción no se puede deshacer.",
      deleteNamedMessage: 'Se eliminará "{name}".',
      cancelCartTitle: "¿Cancelar cesta?",
      cancelCartMessage: "Se perderán los productos seleccionados y la reserva pendiente.",
      clearCartTitle: "¿Vaciar cesta?",
      clearCartMessage: "Se eliminarán todos los productos de la cesta.",
      removeCartItemTitle: "¿Eliminar producto?",
      removeCartItemMessage: 'Se quitará "{name}" de la cesta.',
      cancelReservationTitle: "¿Cancelar reserva?",
      cancelReservationMessage: "La reserva quedará cancelada. Esta acción no se puede deshacer.",
      closeMaintenanceTitle: "¿Cerrar mantenimiento?",
      closeMaintenanceMessage: "La unidad volverá a estar disponible en el inventario.",
      pickupTitle: "Confirmar entrega",
      pickupMessage: "¿Confirmas que el material ha sido entregado al colaborador?",
      returnTitle: "Confirmar recepción",
      returnMessage: "¿Confirmas la recepción y el estado del material devuelto?",
      submitReservationTitle: "¿Confirmar reserva?",
      submitReservationMessage: "Una vez confirmada, se asignarán las unidades.",
    },
    nav: {
      home: "Inicio",
      back: "Volver",
      backToHome: "Volver al inicio",
      backToBooking: "Volver a reservas",
      employeeSection: "Navegación de reservas",
      adminSection: "Navegación de administración",
      quickAccess: "Acceso rápido",
    },
    flow: {
      title: "Progreso de reserva",
      stepType: "Tipo",
      stepCategory: "Categoría",
      stepSubCategory: "Subcategoría",
      stepProducts: "Productos",
      stepCart: "Cesta y fechas",
      stepConfirm: "Confirmación",
    },
    states: {
      ALL: "Todas",
      PENDING_CHECKOUT: "Pendiente de tramitar",
      BOOKED: "Solicitada",
      PICKED_UP: "En uso",
      RETURNED: "Devuelta",
      RETURNED_WITH_INCIDENT: "Devuelta con incidencia",
      CANCELLED: "Cancelada",
      CANCELLED_ADMIN: "Cancelada (admin)",
      EXPIRED: "Expirada",
    },
    reservation: {
      collaborator: "Colaborador",
      dates: "Fechas",
      state: "Estado",
      items: "Productos",
      center: "Centro",
      dateRangeCalendar: {
        ariaLabel: "Calendario de reserva del {range}",
        legendRange: "Periodo del préstamo",
        legendPickup: "Recogida",
        legendReturn: "Devolución",
        selectedDay: "Recogida y devolución: {date}",
        startDay: "Recogida: {date}",
        endDay: "Devolución: {date}",
        inRangeDay: "Día del préstamo: {date}",
      },
    },
    items: "productos",
    detail: {
      cancel: "Cancelar reserva",
    },
    errors: {
      BOOKING_RESERVATION_EXPIRED: "La reserva ha expirado",
      BOOKING_INSUFFICIENT_AVAILABILITY: "No hay suficiente disponibilidad",
      BOOKING_INVALID_DATE_RANGE: "Rango de fechas inválido",
      BOOKING_FORBIDDEN_CENTER: "No tienes acceso a este centro",
      BOOKING_INVALID_STATE: "Estado de reserva inválido",
      loadFailed: "Error al cargar los datos",
      deleteFailed: "Error al eliminar el elemento",
    },
  },

  common: {
    view: "Ver",
    confirm: "Confirmar",
    cancel: "Cancelar",
    apply: "Aplicar",
    date: "Fecha",
    search: "Buscar",
    type: "Tipo",
    actor: "Actor",
    close: "Cerrar",
    name: "Nombre",
    description: "Descripción",
    save: "Guardar",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    notes: "Notas",
  },

  pagination: {
    prev: "Anterior",
    next: "Siguiente",
  },

  identify_collaborator: "Identificar colaborador",
  identify_collaborator_description: "Introduce el UID LDAP del colaborador",
  search_collaborator: "Buscar",
  search_collaborator_placeholder: "Ej: ASANCHE01",
  delays_data: "Datos retrasos",
  delay_invalid_uid_title: "UID no válido",
  delay_invalid_uid_description: "Introduce un UID alfanumérico (ej. ASANCHE01)",
  delay_lookup_confirm_title: "Confirma los datos del colaborador",
  delay_lookup_confirm_description: "Verifica la identidad antes de registrar el retraso",
  delay_lookup_uid_label: "UID",
  delay_lookup_name_label: "Nombre",
  delay_lookup_email_label: "Correo electrónico",
  delay_lookup_job_label: "Puesto",
  delay_confirm_and_create: "Confirmar y crear retraso",
  delay_lookup_search_again: "Buscar otro colaborador",
  delay_lookup_not_found: "No se encontró ningún colaborador con ese UID",
  delay_lookup_not_found_detail: "No hay resultados para {uid} en el directorio de personas",
  delay_lookup_error: "No se pudo consultar el colaborador. Inténtalo de nuevo",
  delay_confirm_identity: "¿Eres {name}?",
  delay_confirm_yes: "Sí, soy yo",
  delay_confirm_no: "No, buscar otro",
  delay_justification: "Justificación del retraso",
  delay_justification_text: "Completa la información del retraso antes de firmar",
  delay_category_label: "Motivo",
  delay_reason_label: "Motivo",
  delay_reason_description_placeholder: "Describe brevemente el motivo del retraso (opcional)",
  delay_preview_draft: "Vista previa (borrador)",
  delay_sign_success: "Retraso firmado correctamente",
  delay_sign_error: "Error al firmar el retraso. Inténtalo de nuevo",
  justify_delay: "Justificar retraso",
  delay_duration: "Duración del retraso",
  delay_table_name: "Nombre",
  delay_table_email: "Email",
  delay_table_date: "Fecha",
  delay_table_scheduled_start: "Inicio previsto",
  delay_table_arrival_time: "Hora de llegada",
  delay_table_difference: "Diferencia (min)",
  delay_table_state: "Estado",
  delay_table_process: "Proceso",
  delay_action_download_pdf: "Descargar PDF",
  delay_action_resume: "Retomar proceso",
  delay_arrival_save_success: "Hora de llegada actualizada correctamente",
  delay_arrival_save_error: "No se pudo actualizar la hora de llegada",
  delay_arrival_invalid_time: "La hora de llegada no es valida",
  delay_arrival_before_scheduled: "La hora de llegada no puede ser anterior al inicio planificado",
  scheduledStart: "Inicio planificado",
  actual_clock_in: "Hora de llegada",
  late: "Tarde",
  on_time: "A tiempo",
  pending: "Pendiente",
  review_sign_documentation: "Revisar y firmar documentación",
  review_sign_description: "Revisa el documento y firma digitalmente",
  document_preview: "Vista previa del documento",
  view_fullscreen: "Pantalla completa",
  justification_form: "Justificación de retraso",
  digital_sign: "Firma digital",
  clear_signature: "Borrar firma",
  sign_here_placeholder: "Firma aquí",
  cancel_and_edit: "Cancelar y editar",
  sign_and_submit: "Firmar y enviar",
  pdf_title: "Detalles del fichaje y retraso",
  pdf_registry_id: "ID DEL REGISTRO:",
  pdf_generation_date: "FECHA DE GENERACIÓN:",
  pdf_employee_data: "Datos del empleado",
  pdf_employee_name: "NOMBRE",
  pdf_employee_email: "EMAIL",
  pdf_delay_details: "Detalles del retraso",
  pdf_scheduled_date: "FECHA PLANIFICADA",
  pdf_scheduled_time: "HORA PLANIFICADA",
  pdf_actual_time: "HORA DE ENTRADA REAL",
  pdf_delay_minutes: "MINUTOS DE RETRASO",
  pdf_current_state: "ESTADO ACTUAL",
  pdf_justification: "Justificación",
  pdf_category: "CATEGORÍA",
  pdf_description: "DESCRIPCIÓN",
  pdf_signature: "Firma del empleado",
  pdf_footer: "Decathlon España - Documento Confidencial",
  delay_uuid: "UUID retraso",
  boss: "Responsable",
  delay_data: "Datos de retrasos",
  delays_details: "Detalle retraso",
  delays_sign: "Firma retraso",
  analytics_total_late: "Total llegadas tarde",
  analytics_avg_delay: "Retraso medio (min)",
  analytics_resolution_rate: "Tasa resolución (%)",
  analytics_export: "Exportar Excel",
  delay_uid_filter: "UID colaborador",
  delayCenters: "centros",
  reasonCategories: "motivos",
  delay_uid_filter_placeholder: "Introduce UIDs separados por coma",
  delay_uid_filter_search: "Buscar",

  delay_center_form: {
    name_placeholder: "Nombre del centro",
    center_code_placeholder: "Código del centro",
  },

  reason_category_form: {
    name_placeholder: "Nombre del motivo",
    description_placeholder: "Descripción del motivo",
  },
  delete_reason_category_description: "Estás a punto de eliminar un motivo de retraso",
  deleted_reason_category: "Motivo del retraso eliminado",

  no_role_title: "Sin acceso",
  no_role_description:
    "Tu cuenta no tiene ningún rol asignado. Contacta con tu responsable para solicitar el acceso en Identity Access.",
  no_role_contact: "Contactar con soporte",
  more: "Más",

  visitors_data_integrity_conflict: "No se puede crear o actualizar el visitante por una restricción de integridad.",
  visitors_internal_error: "Ha ocurrido un error interno.",
  visitors_duplicate_badge: "Ya existe un visitante con el mismo número de acreditación.",
  collaborators: "colaboradores",
  text: "Texto",
  select_search: "Selección",
  checkbox: "Casilla",
  normal: "Normal",
  phone: "Teléfono",
  delays: "Retrasos",
  language: "Idioma",
  field_obligatory: "Este campo es obligatorio.",
  field_invalid_email: "Introduce un correo válido (nombre@dominio.com).",
  field_invalid_phone: "Introduce un teléfono válido.",
  field_invalid_dni: "Introduce un DNI válido",

  select_reason_delay: "Selecciona un motivo",
  delay_reason_description_label: "Descripción del motivo",
  job_name: "Puesto de trabajo",
  minute: "minuto",
  minutes: "minutos",

  booking_type: "Tipo de reserva",
  booking_category: "Categoría",
  booking_subcategory: "Subcategoría",
  bookingTypes: "Tipo",
  bookingCenters: "Centros",
  bookingCategories: "Categorias",
  bookingSubcategories: "Subcategorias",
  select_booking_type: "Selecciona un tipo",
  select_booking_center: "Selecciona un centro",
  select_booking_category: "Selecciona una categoría",
  select_booking_subcategory: "Selecciona una subcategoría",


  remove_delete_success: "Retraso eliminado correctamente",
  remove_delete_error: "No se pudo eliminar el retraso. Inténtalo de nuevo",
  remove_delay_description: "Estás a punto de eliminar un retraso",
  booking_center: "Centro",
  saving: "Guardando...",
  save_changes: "Guardar cambios",
  visitors_number: "Nº de visitantes",
  export_to_excel: "Exportar"
};

export default message;
